import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { selector } from "../../../api";
import { accountingCRUD } from "../../../actions/accounting";
import { TableShared } from "../../../shared";
import { char } from "../../../utils";
import {
  Badge,
  Button,
  ConfigProvider,
  Dropdown,
  Space,
  notification,
} from "antd";
import {
  PlusCircleOutlined,
  MoreOutlined,
  DeleteOutlined,
  EyeOutlined,
  EditOutlined,
} from "@ant-design/icons";
import CloseIcon from "@rsuite/icons/Close";
import { Input, InputGroup, SelectPicker } from "rsuite";


export const AddmissionContent = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const [searchType, setSearchType] = useState(null);
  const [name, setName] = useState("");
  const [indexNumber, setIndexNumber] = useState("");
  const [phone, setPhone] = useState("");
  const [searchIndex, setSearchIndex] = useState(0);

  const [api, contextHolder] = notification.useNotification();

  const user = selector.User();

  useEffect(() => {
    if(searchType){
      setLoading(true);
      setTimeout(() => {
        accountingCRUD
          .loadStudentAdmissionByFilter(postsPerPage, nextPage, name, phone, indexNumber, "-id")
          .then((resp) => {
            setData(resp.data.results);
            setCount(resp.data.count);
          })
          .catch((error) => {
            api.error({
              message: error.message,
              description:
                "Oops! It looks like you're not connected to the network. Please check your network connectivity and try again",
              placement: "topRight",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    } else {
      setLoading(true);
      setTimeout(() => {
        accountingCRUD
          .loadStudentAdmission(postsPerPage, nextPage, value, "-id")
          .then((resp) => {
            setData(resp.data.results);
            setCount(resp.data.count);
          })
          .catch((error) => {
            api.error({
              message: error.message,
              description:
                "Oops! It looks like you're not connected to the network. Please check your network connectivity and try again",
              placement: "topRight",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    }
  }, [page, postsPerPage, value, index, nextPage, searchIndex]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 50,
    },
    {
      key: "index_number",
      title: "Index Number",
      dataIndex: "index_number",
      sortable: true,
      width: 130,
    },
    {
      key: "name",
      title: "Full Name",
      dataIndex: "name",
      sortable: true,
      fwidth: 230,
    },
    {
      key: "address",
      title: "Address",
      dataIndex: "address",
      sortable: true,
      width: 130,
    },
    {
      key: "phone_number",
      title: "Phone Number",
      dataIndex: "phone_number",
      sortable: true,
      width: 100,
    },
    {
      key: "email",
      title: "Email Address",
      dataIndex: "email",
      sortable: true,
      width: 180,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sortable: true,
      width: 100,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: "Edit",
                key: "edit",
                icon: <EditOutlined />,
              },
              {
                label: "View",
                key: "view",
                icon: <EyeOutlined />,
              },
              {
                label: "Delete",
                key: "delete",
                icon: <DeleteOutlined />,
              },
            ],
            onClick: (event) => {
              switch (event.key) {
                case "1":
                  setOpen(true);
                  break;
                default:
              }
            },
          }}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
          trigger={["click"]}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"small"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    sn: i + 1,
    index_number: dt.index_number ? char.toUpperCase(dt.index_number) : "N/A",
    name: dt.name ? char.toTitleCase(dt.name) : "N/A",
    address: dt.address ? char.toTitleCase(dt.address) : "N/A",
    phone_number: dt.phone_number ? dt.phone_number : "N/A",
    email: dt.email ? dt.email : "N/A",
    status: dt.is_active ? (
      <span class="badge badge-soft-success badge-border">
        {char.toTitleCase("active")}
      </span>
    ) : (
      <span class="badge badge-soft-danger badge-border">
        {char.toTitleCase("inactive")}
      </span>
    ),
  }));

  const search = (
    <>
      <div className="col-md-3 col-sm-12">
        <SelectPicker
          size="lg"
          style={{
            width: "100%",
          }}
          placeholder="Search by ...."
          optionFilterProp="children"
          onChange={(e) => {
            setSearchType(e);
            setName("");
            setIndexNumber("");
            setPhone("");
          }}
          cleanable
          onClean={() => {
            setSearchType(null);
            setName("");
            setIndexNumber("");
            setPhone("");
            setSearchIndex(searchIndex + 1);
          }}
          data={[
            {
              label: "Student Name",
              value: "name",
            },
            {
              label: "Index Number",
              value: "indexNumber",
            },
            {
              label: "Phone Number",
              value: "phone",
            },
          ]}
        />
      </div>
      {searchType === "name" && (
        <div className="col-md-3 col-sm-12">
          <InputGroup inside style={{ width: 300 }}>
            <Input
              placeholder="Search by student name"
              size="lg"
              value={name}
              onChange={(e) => setName(char.toLowerCase(e))}
            />
            {name && (
              <InputGroup.Button
                size="lg"
                onClick={() => {
                  setName("");
                  setSearchIndex(searchIndex + 1);
                }}
              >
                <CloseIcon />
              </InputGroup.Button>
            )}
          </InputGroup>
        </div>
      )}
      {searchType === "indexNumber" && (
        <div className="col-md-3 col-sm-12">
          <InputGroup inside style={{ width: 300 }}>
            <Input
              placeholder="Search by index number"
              size="lg"
              value={indexNumber}
              onChange={(e) => setIndexNumber(char.toLowerCase(e))}
            />
            {indexNumber && (
              <InputGroup.Button
                size="lg"
                onClick={() => {
                  setIndexNumber("");
                  setSearchIndex(searchIndex + 1);
                }}
              >
                <CloseIcon />
              </InputGroup.Button>
            )}
          </InputGroup>
        </div>
      )}
      {searchType === "phone" && (
        <div className="col-md-3 col-sm-12">
          <InputGroup inside style={{ width: 300 }}>
            <Input
              placeholder="Search by phone number"
              size="lg"
              value={phone}
              onChange={(e) => setPhone(char.toLowerCase(e))}
            />
            {phone && (
              <InputGroup.Button
                size="lg"
                onClick={() => {
                  setPhone("");
                  setSearchIndex(searchIndex + 1);
                }}
              >
                <CloseIcon />
              </InputGroup.Button>
            )}
          </InputGroup>
        </div>
      )}
      {searchType && (
        <div className="col-md-2 col-sm-12">
          <button
            className="btn btn-soft-info"
            onClick={() => {
              setSearchIndex(searchIndex + 1);
            }}
          >
            <span className="bi bi-search"></span> &nbsp; Search
          </button>
        </div>
      )}
      <div
        className={
          searchType
            ? "col-md-4 col-sm-12 d-flex flex-row-reverse"
            : "col-md-9 col-sm-12 d-flex flex-row-reverse"
        }
      >
        {null}
      </div>
    </>
  );

  return (
    <>
      {contextHolder}
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-dark">Student Addmission</p>
          </div>
          <hr className="mt-3" />
        </div>
        <TableShared
          setOpen={setOpen}
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={null}
          link={"#"}
          showButton={true}
          search={search}
          showSearch={true}
          setLoading={setLoading}
        />
      </div>
    </>
  );
};
